import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, inject } from '@angular/core';

import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { BetBuilderTrackingValues } from '../../bet-builder/bet-builder-tracking';
import { EventMarketsTabBarItem, SubTab } from '../../event-details-common/header/tab-group/event-header-tab-bar.models';

@Component({
    selector: 'ms-header-sub-navigation',
    templateUrl: './header-sub-navigation.component.html',
    styleUrls: ['./header-sub-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class HeaderSubNavigationComponent implements OnChanges {
    subNavigationTabs: SubTab[] | undefined;
    @Input() tabs: EventMarketsTabBarItem[];
    @Output() tabChange = new EventEmitter<string>();
    private trackingService = inject(TrackingService);

    private readonly MarketSwitcherMessage = 'market switcher';
    private readonly SubNavigationMessage = 'sub navigation';

    ngOnChanges(): void {
        this.subNavigationTabs = this.active?.subNavigationTabs;
        if (this.subNavigationTabs?.length && !this.activeSubTab) {
            this.subNavigationTabs[0].active = true;
            this.tabSelected(undefined, this.subNavigationTabs[0].id);
        }
    }

    tabSelected($event: Event | undefined, tabId: string): void {
        this.active?.subNavigationTabs?.forEach((tab) => {
            tab.active = tab.id === tabId;
            if (tab.active) {
                this.trackSet(tab?.name);
            }
        });
        this.tabChange.emit(tabId);
    }

    get active(): EventMarketsTabBarItem | undefined {
        return this.tabs && this.tabs.find((tab) => !!tab.active);
    }

    get activeSubTab(): SubTab | undefined {
        return this.active?.subNavigationTabs?.find((tab) => !!tab.active);
    }

    private trackSet(name?: string) {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: this.MarketSwitcherMessage,
            [trackingConstants.COMPONENT_LABEL_EVENT]: this.SubNavigationMessage,
            [trackingConstants.COMPONENT_ACTION_EVENT]: BetBuilderTrackingValues.Click,
            [trackingConstants.COMPONENT_POSITION_EVENT]: this.active?.title,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: BetBuilderTrackingValues.EventDetails,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: name,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }
}
